import { render, staticRenderFns } from "./ToplamB2BMusteriSayisi.vue?vue&type=template&id=1789b891&scoped=true"
import script from "./ToplamB2BMusteriSayisi.vue?vue&type=script&lang=js"
export * from "./ToplamB2BMusteriSayisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1789b891",
  null
  
)

export default component.exports